import ReportParent from './ReportParent';
export default ReportParent;
